import api from '@dashboard/services/axiosApi'
import { useConfigStore } from '@dashboard/stores/configStore'

/**
 * Refresh only the owner (entitlement and billing) payload for a project.
 * Never refetches the config itself, so buffered draft edits survive a
 * billing change.
 */
export async function refreshBillingOwner(teamPid: string | number | null) {
  if (teamPid === null) {
    return
  }
  const configStore = useConfigStore()
  const { data } = await api.get(`/api/${teamPid}/configs/current`)
  if (String(configStore.currentTeamPid) === String(teamPid) && configStore.fullResponse) {
    configStore.fullResponse.owner = data.owner
  }
}
